module.exports = __webpack_public_path__ + "img/20191122163638360截图20191122162528255.058b7b0e.jpg";